import { Directive, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { HeaderService } from 'src/app/core/services/header.service';

@Directive({
  selector: '[appServiceTracker]',
  standalone: true,
})
export class ServiceTrackerDirective implements AfterViewInit, OnDestroy {
  private observer!: IntersectionObserver;
  private firstIntersection = true;

  constructor(
    private el: ElementRef,
    private headerService: HeaderService
  ) {}

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!this.firstIntersection) {
          this.headerService.toggleServiceButtonVisible(!entry.isIntersecting);
        }
        this.firstIntersection = false;
      },
      {
        root: null,
        threshold: 0.1,
      }
    );

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
      this.headerService.toggleServiceButtonVisible(true);
    }
  }
}
